import type { VentCap } from '@si/types';
import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  ventCap: Omit<VentCap, 'id' | 'createdAt' | 'updatedAt'>;
}

export function useCreateVentCap() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ ventCap }: Params) =>
      post({
        url: '/api/ventcaps',
        body: ventCap,
      }),
    onSuccess: (_, { ventCap }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getVentCaps(
          ventCap.projectId.toString(),
          ventCap.installationId.toString()
        ),
      });
    },
  });

  const createVentCap = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    createVentCap,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
